/* RSC Health - Campaign landing behaviors (Phase 4; DESIGN.md §3 "Campaign landing").
   Plain ES5 IIFE, guarded on [data-rsc-campaign]. Two jobs only:
     1. Featured-panel "+ Add to cart" cards that carry a data-variant-id → /cart/add.js
        (cards without a variant id are plain product-page links and need no JS).
     2. The ZIP availability check: reuse the shared window.RSC module
        (geocodeZip + withinRadius over window.RSC.centers) to report how many test
        centers sit within 40 miles of the entered ZIP. Geocoding is NOT reimplemented
        here; if window.RSC is unavailable the widget degrades to a Find a Test Center
        link. No PHI - the ZIP is only used client-side for the distance count. */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsc-campaign]');
  if (!root) return;

  var FIND_URL = '/pages/find-a-test-center';
  var RADIUS_MI = 40;

  /* ---- 1. featured-panel "+ Add to cart" ---- handled globally by rsc-atc.js (adds →
     /cart, visible error on failure). No per-page handler here. ---- */

  /* ---- 2. ZIP availability check (reuses window.RSC - no geocoding reimplemented) ---- */
  var widget = root.querySelector('[data-rsc-zip]');
  if (!widget) return;

  var input = widget.querySelector('[data-rsc-zip-input]');
  var go = widget.querySelector('[data-rsc-zip-go]');
  var result = widget.querySelector('[data-rsc-zip-result]');
  if (!input || !go || !result) return;

  function esc(s) {
    return (window.RSC && window.RSC.esc) ? window.RSC.esc(s) : String(s == null ? '' : s);
  }

  function findLink(label) {
    return '<a href="' + FIND_URL + '">' + esc(label) + '</a>';
  }

  function show(html) {
    result.hidden = false;
    result.innerHTML = html;
    var skip = result.querySelector('[data-rsc-zip-skip]');
    if (skip) {
      skip.addEventListener('click', function (e) { e.preventDefault(); result.hidden = true; });
    }
  }

  function run() {
    var zip = (input.value || '').trim();
    if (!/^\d{5}$/.test(zip)) { show('Please enter a 5-digit ZIP.'); return; }

    // window.RSC unavailable → degrade to a plain Find a Test Center link.
    if (!window.RSC || !window.RSC.geocodeZip || !window.RSC.withinRadius) {
      show(findLink('See test centers near you →'));
      return;
    }

    window.RSC.geocodeZip(zip, function (geo) {
      if (!geo) { show(findLink('See test centers near you →')); return; }
      var near = window.RSC.withinRadius(window.RSC.centers || [], geo, RADIUS_MI);
      if (!near.length) {
        show('No test centers within ' + RADIUS_MI + ' miles yet: ' + findLink('search the full list →'));
        return;
      }
      show('<span class="ac-ok">✓ ' + near.length + ' test center' + (near.length === 1 ? '' : 's') +
        ' within ' + RADIUS_MI + ' miles of ' + esc(zip) + '.</span> ' +
        findLink('See them →') +
        '<a class="ac-skip" href="#" data-rsc-zip-skip>or skip this</a>');
    });
  }

  go.addEventListener('click', run);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); run(); }
  });
})();
